import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title rounded-lg" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "cardTitle" }, "Dry Ducks", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "cardTitle" }, "Swimming Ducks", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "nftGrid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTCard = _resolveComponent("NFTCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title === 'vault')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nfts, (nft) => {
        return (_openBlock(), _createBlock(_component_NFTCard, {
          key: nft,
          nft: nft,
          onSelected: _ctx.handleSelected
        }, null, 8, ["nft", "onSelected"]))
      }), 128))
    ])
  ]))
}